import { cancelSubscriptionApi as generatedCancelSubscriptionApi } from '../generated/billing/cancelSubscription';

import { getMySubscriptionStatusApi } from './getMySubscriptionStatus';

const cancelSubscriptionApi = generatedCancelSubscriptionApi.enhanceEndpoints({
  endpoints: {
    cancelSubscription: {
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          getMySubscriptionStatusApi.util.updateQueryData('getMySubscriptionStatus', undefined, (draft) => {
            draft.status = data.stripeStatus;
            draft.period.cancelAt = data.cancelAt ?? null;
          }),
        );
      },
    },
  },
});

export const { useCancelSubscriptionMutation } = cancelSubscriptionApi;
